export const ACCOUNTS = '/accounts';

export const LOGIN = '/accounts/sign-in';
export const REGISTER = '/accounts/sign-up';
export const RECOVER_PASSWORD = '/accounts/forgot-password';

export const ERRORS = '/errors';

export const APP = '/app';

export const HOME = '/';

export const TERMS_AND_CONDITIONS = '/terms-and-conditions';

export const REPORTS_HOME = '/reports';
export const PRODUCTS_HOME = '/products';
export const CATALOG_HOME = '/catalogs';
export const VENDORS_HOME = '/vendors';
export const MANUFACTURERS_HOME = '/manufacturers';
export const COLLABORATORS_HOME = '/collaborators';
export const COLLECTIONS_HOME = '/collections';


export const NEW_PRODUCT = '/products/new';
export const SHOW_PRODUCT = '/products/:id';
export const EDIT_PRODUCT = '/products/:id/edit';

export const COLLABORATORS_ROLES = '/collaborators/roles';
export const COLLABORATORS_INVITES = '/collaborators/invites';

export const SHOW_MANUFACTURER = '/manufacturers/:id';
export const SHOW_VENDOR = '/vendors/:id';

export const UPGRADE = '/upgrade';

export const ACCEPT_INVITES = '/accept-invite';

export const PROFILE = '/profile';

export const CREATE_MANUFACTURER = '/manufacturers/new';
export const CREATE_VENDOR = '/vendors/new';

/* Utility functions */

export const showProductPath = id => `/products/${id}`;

export const productPath = (id, owner = null) => {
  const path = `/products/${id}`;
  if (owner === null) {
    return path;
  }
  return `${path}?owner=${owner}`;
};

export const productEditPath = id => `/products/${id}/edit`;

export const showManufacturerPath = id => `/manufacturers/${id}`;

export const showVendorPath = id => `/vendors/${id}`;

/* Default setups */
export const DEFAULT_PUBLIC_ROUTE = LOGIN;
export const DEFAULT_PRIVATE_ROUTE = HOME;



// WEBPACK FOOTER //
// ./src/app/components/Routes/constants.js